/* ═══════════════════════════════════════════════════════════
   NORATIV BUNDLE BUILDER — JavaScript v1.0
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── STATE ─────────────────────────────────────────────── */
  const BB = {
    items: [],
    tiers: [],
    settings: {},
    els: {},
    activeFilter: 'all',
  };

  /* ── SIZE GUIDE ────────────────────────────────────────── */
  function toggleSG(show) {
    const root = document.querySelector('[data-bb-section]');
    const modal = root ? root.querySelector('[data-bb-sg-modal]') : null;
    if (!modal) return;
    modal.classList.toggle('active', show);
    document.body.style.overflow = show ? 'hidden' : '';
  }

  /* ── INIT ──────────────────────────────────────────────── */
  function init() {
    const root = document.querySelector('[data-bb-section]');
    if (!root) return;

    // Parse settings from data attributes
    BB.settings = JSON.parse(root.dataset.bbSettings || '{}');
    BB.tiers = (BB.settings.tiers || []).filter(t => t.enabled).sort((a, b) => a.qty - b.qty);

    // Cache DOM elements
    BB.els = {
      root,
      progressFill: root.querySelector('.bb-progress-fill'),
      progressTiers: root.querySelectorAll('.bb-progress-tier'),
      progressPill: root.querySelector('.bb-progress-pill'),
      filterBtns: root.querySelectorAll('.bb-filter-btn'),
      cards: root.querySelectorAll('.bb-card'),
      sidebarBody: root.querySelector('.bb-sidebar-body'),
      sidebarItems: root.querySelector('.bb-sidebar-items'),
      sidebarEmpty: root.querySelector('.bb-sidebar-empty'),
      sidebarCount: root.querySelector('.bb-sidebar-count'),
      sidebarSubtotal: root.querySelector('[data-bb-subtotal]'),
      sidebarDiscount: root.querySelector('[data-bb-discount]'),
      sidebarDiscountRow: root.querySelector('[data-bb-discount-row]'),
      sidebarTotal: root.querySelector('[data-bb-total]'),
      checkoutBtn: root.querySelector('.bb-checkout-btn'),
      drawer: document.querySelector('.bb-drawer'),
      drawerBadge: document.querySelector('.bb-drawer-badge'),
      drawerText: document.querySelector('.bb-drawer-text'),
      drawerPrice: document.querySelector('.bb-drawer-price'),
      drawerDiscount: document.querySelector('.bb-drawer-discount'),
      drawerBody: document.querySelector('.bb-drawer-body'),
      drawerItems: document.querySelector('.bb-drawer-items'),
      drawerCheckout: document.querySelector('.bb-drawer-checkout-btn'),
      drawerToggleText: document.querySelector('[data-bb-toggle-text]'),
      overlay: document.querySelector('.bb-overlay'),
      toast: document.querySelector('.bb-toast'),
    };
    BB.els.sgTriggers = BB.els.root.querySelectorAll('[data-bb-sg-trigger]');
    BB.els.sgCloses = BB.els.root.querySelectorAll('[data-bb-sg-close]');

    bindEvents();
    updateUI();
  }

  /* ── EVENT BINDING ─────────────────────────────────────── */
  function bindEvents() {
    // Filter buttons
    BB.els.filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        BB.activeFilter = btn.dataset.bbFilter;
        BB.els.filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        filterProducts();
      });
    });

    // Add to bundle buttons
    BB.els.cards.forEach(card => {
      const btn = card.querySelector('.bb-card-atb');
      if (btn) btn.addEventListener('click', () => addFromCard(card));
    });

    // Drawer toggle
    if (BB.els.drawer) {
      const handle = BB.els.drawer.querySelector('.bb-drawer-handle');
      if (handle) handle.addEventListener('click', toggleDrawer);
    }
    if (BB.els.overlay) {
      BB.els.overlay.addEventListener('click', closeDrawer);
    }

    // Checkout buttons
    if (BB.els.checkoutBtn) BB.els.checkoutBtn.addEventListener('click', checkout);
    if (BB.els.drawerCheckout) BB.els.drawerCheckout.addEventListener('click', checkout);

    // Card Galleries (Swipe & Arrows)
    BB.els.cards.forEach(card => {
      const track = card.querySelector('.bb-card-gallery-track');
      const dots = card.querySelectorAll('.bb-card-dot');
      const prev = card.querySelector('.bb-card-arrow.prev');
      const next = card.querySelector('.bb-card-arrow.next');

      if (track) {
        // Dot Sync on Scroll
        if (dots.length > 1) {
          track.addEventListener('scroll', () => {
            const index = Math.round(track.scrollLeft / track.clientWidth);
            dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
          }, { passive: true });
        }

        // Arrow Clicks
        if (prev) prev.addEventListener('click', (e) => {
          e.preventDefault();
          track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', (e) => {
          e.preventDefault();
          track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        });
      }
    });

    // Size Guide triggers
    if (BB.els.sgTriggers) {
      BB.els.sgTriggers.forEach(btn => btn.addEventListener('click', () => toggleSG(true)));
    }
    if (BB.els.sgCloses) {
      BB.els.sgCloses.forEach(btn => btn.addEventListener('click', () => toggleSG(false)));
    }
  }

  /* ── ADD FROM CARD ─────────────────────────────────────── */
  function addFromCard(card) {
    const select = card.querySelector('.bb-card-size-select');
    if (!select) return;

    const option = select.selectedOptions[0];
    if (!option || option.disabled) {
      select.style.borderColor = '#e74c3c';
      select.style.animation = 'bb-shake 0.3s ease';
      setTimeout(() => { select.style.borderColor = ''; select.style.animation = ''; }, 400);
      return;
    }

    const item = {
      variantId: parseInt(option.value),
      productTitle: card.dataset.bbTitle || '',
      size: option.textContent.trim(),
      price: parseInt(option.dataset.bbPrice || '0'),
      imageUrl: card.dataset.bbImage || '',
      productId: card.dataset.bbProductId || '',
    };

    BB.items.push(item);

    // Flash button
    const btn = card.querySelector('.bb-card-atb');
    btn.classList.add('added');
    btn.textContent = '✓ Added';
    setTimeout(() => { btn.classList.remove('added'); btn.textContent = 'Add to bundle'; }, 1200);

    showToast(item.productTitle + ' (' + item.size + ')');
    updateUI();
  }

  /* ── REMOVE ITEM ───────────────────────────────────────── */
  function removeItem(index) {
    BB.items.splice(index, 1);
    updateUI();
  }
  window.__bbRemove = removeItem;

  /* ── GET ACTIVE TIER ───────────────────────────────────── */
  function getActiveTier() {
    let active = null;
    const count = BB.items.length;
    for (let i = BB.tiers.length - 1; i >= 0; i--) {
      if (count >= BB.tiers[i].qty) { active = BB.tiers[i]; break; }
    }
    return active;
  }

  function getNextTier() {
    const count = BB.items.length;
    for (const tier of BB.tiers) {
      if (count < tier.qty) return tier;
    }
    return null;
  }

  /* ── CALCULATIONS ──────────────────────────────────────── */
  function getSubtotal() {
    return BB.items.reduce((sum, item) => sum + item.price, 0);
  }

  function getDiscount() {
    const tier = getActiveTier();
    return tier ? tier.discount : 0;
  }

  function getTotal() {
    const sub = getSubtotal();
    const disc = getDiscount();
    return Math.round(sub * (1 - disc / 100));
  }

  function formatMoney(cents) {
    return BB.settings.moneyFormat
      ? BB.settings.moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2))
      : '$' + (cents / 100).toFixed(2);
  }

  /* ── UPDATE UI ─────────────────────────────────────────── */
  function updateUI() {
    updateProgressBar();
    updateSidebar();
    updateDrawer();
  }

  /* ── PROGRESS BAR ──────────────────────────────────────── */
  function updateProgressBar() {
    if (!BB.tiers.length) return;
    const count = BB.items.length;
    const maxTier = BB.tiers[BB.tiers.length - 1];
    const pct = Math.min((count / maxTier.qty) * 100, 100);

    if (BB.els.progressFill) BB.els.progressFill.style.width = pct + '%';

    // Update tier markers
    BB.els.progressTiers.forEach(el => {
      const tierQty = parseInt(el.dataset.bbTierQty);
      el.classList.toggle('reached', count >= tierQty);
      el.classList.toggle('active', false);
    });

    // Mark active (next target) tier
    const next = getNextTier();
    if (next) {
      const nextEl = BB.els.root.querySelector('[data-bb-tier-qty="' + next.qty + '"]');
      if (nextEl) nextEl.classList.add('active');
    }

    // Update pill
    const tier = getActiveTier();
    if (BB.els.progressPill) {
      BB.els.progressPill.textContent = tier
        ? tier.discount + '% OFF!'
        : 'Up to ' + maxTier.discount + '% OFF';
    }
  }

  /* ── SIDEBAR ───────────────────────────────────────────── */
  function updateSidebar() {
    const count = BB.items.length;
    const maxQty = BB.tiers.length ? BB.tiers[BB.tiers.length - 1].qty : 12;

    // Count
    if (BB.els.sidebarCount) BB.els.sidebarCount.textContent = count + '/' + maxQty;

    // Empty/items toggle
    if (BB.els.sidebarEmpty) BB.els.sidebarEmpty.style.display = count ? 'none' : 'block';
    if (BB.els.sidebarItems) {
      BB.els.sidebarItems.style.display = count ? 'flex' : 'none';
      BB.els.sidebarItems.innerHTML = BB.items.map((item, i) => sidebarItemHTML(item, i)).join('');
    }

    // Totals
    const sub = getSubtotal();
    const disc = getDiscount();
    const total = getTotal();

    if (BB.els.sidebarSubtotal) BB.els.sidebarSubtotal.textContent = formatMoney(sub);
    if (BB.els.sidebarDiscountRow) BB.els.sidebarDiscountRow.style.display = disc ? 'flex' : 'none';
    if (BB.els.sidebarDiscount) BB.els.sidebarDiscount.textContent = '-' + disc + '%';
    if (BB.els.sidebarTotal) BB.els.sidebarTotal.textContent = formatMoney(total);

    // Checkout button
    if (BB.els.checkoutBtn) {
      const enabled = count > 0;
      BB.els.checkoutBtn.classList.toggle('enabled', enabled);
      BB.els.checkoutBtn.disabled = !enabled;
    }
  }

  function sidebarItemHTML(item, index) {
    return '<div class="bb-sidebar-item">'
      + '<div class="bb-sidebar-item-img"><img src="' + item.imageUrl + '" alt="" loading="lazy" width="44" height="44"></div>'
      + '<div class="bb-sidebar-item-info">'
      + '<div class="bb-sidebar-item-name">' + escapeHTML(item.productTitle) + '</div>'
      + '<div class="bb-sidebar-item-meta">' + escapeHTML(item.size) + ' · ' + formatMoney(item.price) + '</div>'
      + '</div>'
      + '<button class="bb-sidebar-item-remove" onclick="__bbRemove(' + index + ')" aria-label="Remove">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>'
      + '</button></div>';
  }

  /* ── MOBILE DRAWER ─────────────────────────────────────── */
  function updateDrawer() {
    if (!BB.els.drawer) return;
    const count = BB.items.length;
    const total = getTotal();
    const disc = getDiscount();

    if (BB.els.drawerBadge) BB.els.drawerBadge.textContent = count;
    if (BB.els.drawerText) {
      const next = getNextTier();
      if (disc > 0) {
        const textTemplate = BB.settings.drawer_active_tier_text || '% OFF target reached!';
        BB.els.drawerText.textContent = textTemplate.replace('%', disc + '%');
      } else if (next) {
        const pre = BB.settings.drawer_next_tier_pre || 'Add ';
        const mid = BB.settings.drawer_next_tier_mid || ' more for ';
        const post = BB.settings.drawer_next_tier_post || '% OFF';
        BB.els.drawerText.textContent = pre + (next.qty - count) + mid + next.discount + post;
      } else {
        BB.els.drawerText.textContent = BB.settings.drawer_bundle_text || 'Your bundle';
      }
    }
    if (BB.els.drawerPrice) BB.els.drawerPrice.textContent = formatMoney(total);
    if (BB.els.drawerDiscount) {
      const saved = getSubtotal() - total;
      BB.els.drawerDiscount.textContent = saved > 0 ? '-' + formatMoney(saved) : '';
      BB.els.drawerDiscount.style.display = saved > 0 ? 'inline-block' : 'none';
    }
    if (BB.els.drawerCheckout) BB.els.drawerCheckout.disabled = count === 0;

    // Drawer items
    if (BB.els.drawerItems) {
      BB.els.drawerItems.classList.toggle('is-carousel', count > 3);
      BB.els.drawerItems.innerHTML = BB.items.length
        ? BB.items.map((item, i) => sidebarItemHTML(item, i)).join('')
        : '<p style="text-align:center;color:#999;font-size:13px;padding:16px">' + (BB.settings.emptyMessage || 'Add items to start your bundle') + '</p>';
    }

    // Drawer totals
    const totalsEl = BB.els.drawer.querySelector('.bb-drawer-totals');
    if (totalsEl && count > 0) {
      totalsEl.innerHTML = '<div class="bb-sidebar-row"><span class="bb-sidebar-row-label">Subtotal (' + count + ' items)</span><span class="bb-sidebar-row-value">' + formatMoney(getSubtotal()) + '</span></div>'
        + (disc > 0 ? '<div class="bb-sidebar-row"><span class="bb-sidebar-row-label">Discount</span><span class="bb-sidebar-discount">-' + disc + '%</span></div>' : '')
        + '<div class="bb-sidebar-total"><span>To be paid</span><span>' + formatMoney(total) + '</span></div>';
    } else if (totalsEl) {
      totalsEl.innerHTML = '';
    }
  }

  function toggleDrawer() {
    if (!BB.els.drawer) return;
    const isExpanded = BB.els.drawer.classList.contains('expanded');
    BB.els.drawer.classList.toggle('expanded');

    // Swap text
    if (BB.els.drawerToggleText) {
      const openTxt = BB.settings.drawer_open_text || 'Show your bundle';
      const closeTxt = BB.settings.drawer_close_text || 'Close your bundle';
      // If was expanded (isExpanded=true), we are now CLOSING it, so show OPEN text.
      // If was collapsed (isExpanded=false), we are now OPENING it, so show CLOSE text.
      BB.els.drawerToggleText.textContent = isExpanded ? openTxt : closeTxt;
    }

    if (BB.els.overlay) BB.els.overlay.classList.toggle('active', !isExpanded);
    document.body.style.overflow = isExpanded ? '' : 'hidden';
  }

  function closeDrawer() {
    if (BB.els.drawer) BB.els.drawer.classList.remove('expanded');
    if (BB.els.drawerToggleText) {
      BB.els.drawerToggleText.textContent = BB.settings.drawer_open_text || 'Show your bundle';
    }
    if (BB.els.overlay) BB.els.overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  /* ── FILTER ────────────────────────────────────────────── */
  function filterProducts() {
    const filter = BB.activeFilter;
    BB.els.cards.forEach(card => {
      if (filter === 'all') {
        card.classList.remove('hidden');
      } else {
        card.classList.toggle('hidden', card.dataset.bbCategory !== filter);
      }
    });
  }

  /* ── CHECKOUT ──────────────────────────────────────────── */

  // Locks UpCart out — starts BEFORE fetch, runs until page leaves
  function suppressThirdPartyCart() {
    var killEl = function(/** @type {Element|null} */ el) {
      if (!el) return;
      var e = /** @type {HTMLElement} */ (el);
      e.style.cssText = 'display:none!important;visibility:hidden!important;opacity:0!important;pointer-events:none!important;transform:none!important;';
      e.removeAttribute('open');
      e.removeAttribute('active');
      e.setAttribute('aria-hidden', 'true');
      var maybeClose = /** @type {any} */ (e);
      if (typeof maybeClose.close === 'function') { try { maybeClose.close(); } catch(x) {} }
    };

    // Kill immediately if already in DOM
    killEl(document.querySelector('upcart-cart'));
    killEl(document.querySelector('upcart-backdrop'));

    // Watch for any subsequent open attempts (attribute changes, DOM inserts)
    var observer = new MutationObserver(function() {
      killEl(document.querySelector('upcart-cart'));
      killEl(document.querySelector('upcart-backdrop'));
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open', 'active', 'class', 'style', 'aria-hidden']
    });

    // Safety: disconnect after navigation starts
    window.addEventListener('beforeunload', function() { observer.disconnect(); });
    setTimeout(function() { observer.disconnect(); }, 5000);
  }

  function checkout() {
    if (!BB.items.length) return;
    const disc = getDiscount();

    const btn = BB.els.checkoutBtn || BB.els.drawerCheckout;
    if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

    const lineItemProp = BB.settings.lineItemProp || 'bundle-builder';

    const grouped = {};
    BB.items.forEach(item => {
      grouped[item.variantId] = (grouped[item.variantId] || 0) + 1;
    });

    const payload = {
      items: Object.keys(grouped).map(vid => {
        const props = { '_bundle': lineItemProp };
        if (disc > 0) props['_bundle_discount'] = disc + '%';
        return {
          id: parseInt(vid, 10),
          quantity: grouped[vid],
          properties: props
        };
      })
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    .then(res => {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(() => {
      if (btn) { btn.textContent = BB.settings.checkoutText || 'View Cart'; btn.disabled = false; }

      openCartDrawer();
    })
    .catch(err => {
      console.error('Bundle checkout error:', err);
      if (btn) { btn.textContent = BB.settings.checkoutText || 'Add to Cart'; btn.disabled = false; }
      alert('Something went wrong. Please try again.');
    });
  }

  function openCartDrawer() {
    // UpCart
    if (window.upcart && typeof window.upcart.open === 'function') {
      try { window.upcart.open(); return; } catch(e) {}
    }
    // Custom events (covers most Shopify cart drawer apps)
    ['upcart:open','upcart:added','cart:open','theme:cart:open','PXUTheme:cartDrawer:open'].forEach(function(ev) {
      document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
    });
    // Fallback: click the header cart icon
    var cartBtn = document.querySelector('[data-upcart-open], .cart-count-bubble, header [href*="/cart"], #ngh-cart-icon');
    if (cartBtn) cartBtn.click();
  }

  /* ── TOAST ─────────────────────────────────────────────── */
  function showToast(text) {
    if (!BB.els.toast) return;
    BB.els.toast.querySelector('span').textContent = text + ' added!';
    BB.els.toast.classList.add('show');
    setTimeout(() => BB.els.toast.classList.remove('show'), 2000);
  }

  /* ── HELPERS ───────────────────────────────────────────── */
  function escapeHTML(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ── BOOT ──────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
